import { useEffect, useState } from 'react';
import orderBy from 'lodash/orderBy';
import { Divider, ScoreTitle, Table } from '@/components/tour/game/FinishScreen/styled';
import { formatTime } from '../../service';
import { Props } from './types';

const THStyles = { cursor: 'pointer', padding: '0 5px' };

export const TopTable = (props: Props) => {
  const { data, translation } = props;

  const [sortedData, setSortedData] = useState(data);
  const [sortConfig, setSortConfig] = useState({ key: 'point', direction: 'desc' });

  useEffect(() => {
    setSortedData(data);
  }, [data]);

  const sortData = (key) => {
    let direction = key === 'point' ? 'desc' : 'asc';
    if (sortConfig.key === key) {
      direction = sortConfig.direction === 'asc' ? 'desc' : 'asc';
    }

    let sortedArray;

    if (key === 'point' || key === 'time') {
      const sortKeys = key === 'point' ? ['point', 'time'] : ['time', 'point'];
      const sortDirections = key === 'point' ? [direction, 'asc'] : [direction, 'desc'];

      // @ts-ignore
      sortedArray = orderBy([...sortedData], sortKeys, sortDirections);
    } else {
      sortedArray = [...sortedData].sort((a, b) => {
        if (a[key] < b[key]) {
          return direction === 'asc' ? -1 : 1;
        }
        if (a[key] > b[key]) {
          return direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setSortedData(sortedArray);
    setSortConfig({ key, direction });
  };
  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };

  return (
    <>
      <Divider />
      <ScoreTitle>{translation?.top10Scores || 'Top 10 scores'}</ScoreTitle>
      <Table>
        <tr>
          <th>#</th>
          <th onClick={() => sortData('name')} style={THStyles}>
            {translation?.name || 'Name'} {getSortIndicator('name')}
          </th>
          <th onClick={() => sortData('point')} style={THStyles}>
            {translation?.score || 'Score'} {getSortIndicator('point')}
          </th>
          <th onClick={() => sortData('time')} style={THStyles}>
            {translation?.experienceTime || 'Time'} {getSortIndicator('time')}
          </th>
        </tr>
        {sortedData.length > 0 ? (
          sortedData.map((top, index) => (
            <tr key={top.index}>
              <td>{index + 1}</td>
              <td>{top.name}</td>
              <td>{top.point}</td>
              <td>{formatTime(top.time)}</td>
            </tr>
          ))
        ) : (
          <tr className="no-data">
            <td colSpan={4}>{translation?.noData || 'No data yet'}</td>
          </tr>
        )}
      </Table>
    </>
  );
};
